import { initializeApp } from "firebase/app"
import { getAuth, connectAuthEmulator } from "firebase/auth"
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"

const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = await fetch("/__/firebase/init.json")
    .then(async response => initializeApp(await response.json()))
    .catch(() => initializeApp(config))
const auth = getAuth()
const firestore = getFirestore(app)
const functions = getFunctions(app, "europe-west3")

if (process.env.NODE_ENV === "development") {
    connectFirestoreEmulator(firestore, '127.0.0.1', 8080)
    connectAuthEmulator(auth, "http://127.0.0.1:9099")
    connectFunctionsEmulator(functions, "127.0.0.1", 5001)
}

export const firebase = {
    app,
    auth: auth,
    firestore: firestore,
    functions: functions,
}
